

export const myProfileConstants = [
  {
    icon: "icon-manage_availability",
    label: "Group",
    // value : user ? user['groups'] : '',
  },
  {
    icon: "icon-contact",
    label: "Number",
    // value : user ? user['mobile_number'] : '',
  },
  {
    icon: "icon-file_share",
    label: "Email Address",
    // value : user ? user['email'] : '',
  },
];

// export const myProfileConstants = [

//   {
//     value  : 'icon-manage_availability'
//   }
// ]
